import { Modal } from '@mui/joy';
import { Autocomplete, Button, ModalClose, ModalDialog, ModalOverflow, Typography } from '@mui/joy';
import { FC, useState } from 'react';

interface MonthBilledInProps {
    // Define component props here
    isOpen: boolean;
    onOpenChange: () => void;
    approve: (approve: boolean, month: string) => Promise<void>
}

const MonthBilledIn: FC<MonthBilledInProps> = ({ isOpen, onOpenChange, approve }) => {

    const [monthBilledIn, setMonthBilled] = useState('January')

    const [loading, setLoading] = useState(false)
    return (

        <Modal open={isOpen} onClose={onOpenChange}>
            <ModalOverflow>
                <ModalDialog
                    color="neutral"
                    size="lg"
                    variant="outlined"
                >
                    <ModalClose />
                    <Typography>Month Billed In: </Typography>
                    <div style={{
                        height: 300,
                        width: 300,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 7,

                    }}>
                        <Autocomplete options={['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']} required={true} onChange={(e, v) => {
                            if (v) {
                                setMonthBilled(v)
                            }
                        }} value={monthBilledIn} />
                        <Button onClick={async () => {
                            setLoading(true)
                            await approve(true, monthBilledIn)
                            setLoading(false)

                        }}>Approve Mileage</Button>
                    </div>
                </ModalDialog>
            </ModalOverflow>
        </Modal>


    );
};

export default MonthBilledIn;